const module = { name: 'shared/global/immediateAdLoad', exports: {} }; const exports = module.exports;



import { mps as mps_onLoad } from 'require-global';

const { onLoad } = mps_onLoad;


import { Fandango_debugLog as debugLog } from 'require-core';



const Selectors = {
    ADS: '.js-ad',
}
function onMPSReady({ _queue, insertAd, isAvailable }) {
    const ads = document.querySelectorAll(Selectors.ADS);
    if (!isAvailable || !ads.length || !_queue) {
        return;
    }
    ads.forEach((adDiv) => {
        const { slot, media } = adDiv.dataset;
        if (!slot || media) {
            return;
        }
        debugLog.info(module.name, 'loading', slot);
        _queue.gptloaded.push(() => insertAd(adDiv, slot));
    });
}
module.exports = {
    init() {
        onLoad(onMPSReady);
    }
};
export default module.exports;